import React, { Component } from "react";
import { Modal, Form } from "react-bootstrap";
import Button from "../../components/button/button";
import { NotifierService } from "../../shared/services/notifier.service";
import { SpinnerService } from "../../shared/services/spinner.service";
import { DataService } from "../../shared/services/data.service";

type forgetPasswordProps = {
  show?: any;
  closeForgotPasswordModal?: any;
};

interface ChangePasswordState {
  email?: any;
}

class ForgetPassword extends Component<
  forgetPasswordProps,
  ChangePasswordState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      email: null,
    };
  }

  handleInputChange = (event: any) => {
    const target = event.target;
    var value = target.value;
    const name = target.name;
    this.setState({ [name]: value });
  };

  forgotPassword = async () => {
    const email: any = this.state.email;
    try {
      SpinnerService.show();
      await DataService.put(
        "/users/forgotPassword",
        { email },
        { "Access-Control-Allow-*": "*" },
      );
      NotifierService.success(
        "Please check your Inbox, password is send to your registered mail id.",
      );
      SpinnerService.hide();
    } catch (error) {
      console.error(error);
      SpinnerService.hide();
      NotifierService.error(
        "Unable to connect to server. PLease try after sometime.",
      );
    }
  };

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.closeForgotPasswordModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="modal-header-color p-2">
          <Modal.Title>
            <img
              src="/images/forget_password.png"
              width="40px"
              alt="user icon"
            />
            &nbsp; Forgot Password
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="resetPasswordModal">
            <Form.Group>
              <Form.Control
                type="email"
                name="email"
                id="email"
                placeholder="Registered email e.g. john.smith@acme.com"
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Text
              style={{
                color: "darkgray",
                fontSize: "12px",
                marginBottom: "20px",
                marginTop: "-15px",
              }}
            >
              ** System will send you one time password on the above mentioned
              mail, if the email is registered with us.
            </Form.Text>
            <Form.Group>
              <Button
                className=""
                value="Send Link"
                onClick={() => this.forgotPassword()}
              ></Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

export const ForgetPasswordModal = ForgetPassword;
